import React from "react";
import { Icons } from "../../../assets/icons";
import { EMPTY_STRING } from "../../../constants";

const { BackIcon } = Icons;

const BackButton = (props) => {
  const { onClick, text, showText = true, className = EMPTY_STRING } = props;

  return (
    <>
      <button
        type="button"
        className={`back-route cursor-pointer ${className}`}
        {...(onClick ? { onClick } : {})}
      >
        <BackIcon className="back-icon" />
        {showText && <span className="back-text">{text}</span>}
      </button>
    </>
  );
};

export default BackButton;
